import React from 'react';
import { useTranslation } from 'react-i18next';
import './Download.css';

const Download = () => {
  const { t } = useTranslation();
  return (
    <section id="download" className="download">
      <div className="download__container">
        <div className="download__content">
          <span className="download__label">{t('download.label')}</span>
          <h2 className="download__title">{t('download.title')}</h2>
          <p className="download__subtitle">
            {t('download.subtitle')}
          </p>
          
          <div className="download__qr-grid">
            <div className="download__qr-card">
              <div className="download__qr-code">
                <img 
                  src="/qr-codes/app-store-qr.png" 
                  alt="App Store QR Code" 
                  className="download__qr-image"
                />
              </div>
              <div className="download__qr-info">
                <svg className="download__store-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" fill="currentColor"/>
                </svg>
                <span className="download__store-name">{t('download.appStore.name')}</span>
                <span className="download__store-subtitle">{t('download.appStore.subtitle')}</span>
                <a
                  href="https://apps.apple.com/nl/app/balanzfit/id6756502372"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download__store-button"
                  aria-label="Open BalanzFit in de App Store"
                >
                  Naar App Store
                </a>
              </div>
            </div>
            <div className="download__qr-card">
              <div className="download__qr-code">
                <img
                  src="/qr-codes/play-store-qr.PNG"
                  alt="Google Play QR Code"
                  className="download__qr-image"
                />
              </div>
              <div className="download__qr-info">
                <svg className="download__store-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 3.5C4 2.93 4.62 2.57 5.12 2.84L16.93 9.08C17.46 9.36 17.46 10.11 16.93 10.39L5.12 16.63C4.62 16.9 4 16.54 4 15.97V3.5Z" fill="currentColor"/>
                  <path d="M4 8.76L12.06 13L8.11 15.09L4 12.91V8.76Z" fill="currentColor" opacity="0.75"/>
                  <path d="M4 12.91L8.11 15.09L5.12 16.63C4.62 16.9 4 16.54 4 15.97V12.91Z" fill="currentColor" opacity="0.55"/>
                </svg>
                <span className="download__store-name">Google Play</span>
                <span className="download__store-subtitle">Download voor Android</span>
                <a
                  href="https://play.google.com/store/apps/details?id=com.balanzfit.android&utm_source=emea_Med"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download__store-button"
                  aria-label="Open BalanzFit in Google Play"
                >
                  Naar Google Play
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(Download);






